module.exports = __webpack_public_path__ + "static/media/sample1.4b41a347.pdf";